import { render } from "./CustomerActivityTab.vue?vue&type=template&id=bf8f7510"
import script from "./CustomerActivityTab.vue?vue&type=script&lang=js"
export * from "./CustomerActivityTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AccountReceivable/CustomerActivityTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf8f7510"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf8f7510', __exports__)) {
    api.reload('bf8f7510', __exports__)
  }
  
  module.hot.accept("./CustomerActivityTab.vue?vue&type=template&id=bf8f7510", () => {
    api.rerender('bf8f7510', render)
  })

}


export default __exports__